import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cityReadAction from './cityRead.action.json' assert { type: 'json' }

const cityReadDefinition = defineReadAutoAction(cityReadAction, 'city')

export default cityReadDefinition
